/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setDirectOrder,
  repriceDirectOrder,
  clearDirectOrder,
  cancelDirectOrder,
} from "../store/slices/directOrderSlice";

export function useDirectOrder() {
  const dispatch = useDispatch();
  const line = useSelector((state) => state.directOrder.line);

  const actions = useMemo(
    () => ({
      setDirectOrder: (payload) => dispatch(setDirectOrder(payload)),
      repriceDirectOrder: (payload) => dispatch(repriceDirectOrder(payload)),
      clearDirectOrder: () => dispatch(clearDirectOrder()),
      cancelDirectOrder: () => dispatch(cancelDirectOrder()),
    }),
    [dispatch]
  );

  return { line, hasDirectOrder: !!line, ...actions };
}
